import { createPaddleCustomerPortalSession } from './billing-subscription.api';
import toaster from '../../../../../shared/toaster';

type PaddlePortalAction = 'overview' | 'payment-methods';

type OpenPaddleCustomerPortalParams = {
  customerId: string;
  subscriptionId: string;
  action?: PaddlePortalAction
};

const openPaddleCustomerPortal = async ({
  customerId,
  subscriptionId,
  action = 'payment-methods'
}: OpenPaddleCustomerPortalParams) => {
  if (!customerId || !subscriptionId) {
    toaster.error('Unable to update payment method. Please contact support.');
    return;
  }
  try {
    const response = await createPaddleCustomerPortalSession({
      customerId,
      subscriptionId,
      action,
    });
    const url = (response as any)?.payload?.url;
    if (url) {
      window.open(url, '_blank');
    }
  } catch {
    toaster.error('Failed to open payment methods. Please try again.');
  }
};

export default openPaddleCustomerPortal;
